import api from './api';

export interface CalendarUserBrief {
  id: number;
  name: string;
  avatar: string;
}

export interface CalendarEventProjectRef {
  id: number;
  name: string;
}

export interface CalendarEventCaseRef {
  id: number;
  name: string;
  identifier: string | null;
}

export interface CalendarEventClientRef {
  id: number;
  name: string;
}

export interface CalendarEventApi {
  id: number;
  title: string;
  description: string | null;
  event_type: string;
  start_at: string;
  end_at: string | null;
  all_day: boolean;
  tags: string[];
  creator_id: number;
  creator: CalendarUserBrief | null;
  performers: CalendarUserBrief[];
  performer_ids: number[];
  client_id: number | null;
  client: CalendarEventClientRef | null;
  project_id: number | null;
  case_id: number | null;
  project: CalendarEventProjectRef | null;
  case: CalendarEventCaseRef | null;
  project_label: string | null;
  case_label: string | null;
  practice_area: string | null;
  performer_name: string | null;
}

export interface CalendarEventsListResponse {
  data: CalendarEventApi[];
}

export interface CalendarEventCreatePayload {
  title: string;
  description?: string;
  event_type?: string;
  start_at: string;
  end_at?: string | null;
  all_day?: boolean;
  tags?: string[];
  project_id?: number | null;
  case_id?: number | null;
  practice_area?: string | null;
  performer_ids?: number[];
}

export const calendarService = {
  async list(from: string, to: string, userIds?: number[]): Promise<CalendarEventApi[]> {
    const params: Record<string, string | number[]> = { from, to };
    if (userIds && userIds.length > 0) {
      params.user_ids = userIds;
    }
    const res = await api.get<CalendarEventsListResponse>('/calendar-events', {
      params,
    });
    return res.data.data ?? [];
  },

  async get(id: number): Promise<CalendarEventApi> {
    const res = await api.get<CalendarEventApi>(`/calendar-events/${id}`);
    return res.data;
  },

  async create(payload: CalendarEventCreatePayload): Promise<CalendarEventApi> {
    const res = await api.post<CalendarEventApi>('/calendar-events', payload);
    return res.data;
  },

  async update(id: number, payload: Partial<CalendarEventCreatePayload>): Promise<CalendarEventApi> {
    const res = await api.put<CalendarEventApi>(`/calendar-events/${id}`, payload);
    return res.data;
  },

  async remove(id: number): Promise<void> {
    await api.delete(`/calendar-events/${id}`);
  },
};
